import script from "./ListarCargosFuncionarios.vue?vue&type=script&setup=true&lang=js"
export * from "./ListarCargosFuncionarios.vue?vue&type=script&setup=true&lang=js"

import "./ListarCargosFuncionarios.vue?vue&type=style&index=0&id=702201bb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-702201bb"]])

export default __exports__